import React from "react";
import { useSelector } from "react-redux";

import { Button, Icon } from "../../../components/common";
import { InvoiceSidebarWrapper } from "./InvoiceSidebarWrapper";
import { Invoice, InvoiceStatus } from "../../../types/InvoiceTypes";
import { copyLink, downloadInvoice } from "./handlers";
import { selectCurrentUser } from "../../../store/reducers/user";

type Props = {
  data: Invoice;
};

export const InvoiceSidebarBusiness: React.FC<Props> = ({ data }) => {
  const { public_id, status } = data;
  const currentUser = useSelector(selectCurrentUser);

  const title = status === InvoiceStatus.DRAFT ? "Draft Invoice" : "Invoice";

  const description = "You can request any changes privately from the creator.";

  return (
    <InvoiceSidebarWrapper title={title} text={description}>
      <div className="flex flex-col gap-y-3">
        <Button
          onClick={(e) => copyLink(e, public_id || "")}
          contentClassName="flex flex-row justify-between items-center w-full"
          disabled={!public_id}
        >
          Copy link &nbsp;
          <Icon icon="Link" size={24} className="text-gray-500" disableFill />
        </Button>

        <Button
          onClick={(e) => downloadInvoice(e, data, currentUser)}
          contentClassName="flex flex-row justify-between items-center w-full"
        >
          Download invoice &nbsp;
          <Icon icon="PDF" size={24} className="text-gray-500" disableFill />
        </Button>
      </div>
    </InvoiceSidebarWrapper>
  );
};
